import React from 'react';
import { Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from "@mui/material";

const TaskControls = ({
    taskId,
    uuid,
    onResetTasks,
}) => {
    return (
        <Box className="debugBox" id='taskControls'>
            <Typography variant="body1" component="p" sx={{ mb: 2 }}>
                Debugging Enabled (Task: {taskId})
                UUID: {uuid}
            </Typography>
            <Button
                onClick={onResetTasks}
                variant="contained"
                color="white"
                startIcon={<DeleteIcon />}
                size="small"
                style={{ marginLeft: '10px' }}
            >
                Delete all tasks
            </Button>
        </Box>
    );
};

export default TaskControls;